<template>
  <div>
    <v-card flat class="mb-2">
      <v-card-title class="justify-center">
        <v-btn depressed color="primary" class="black--text" @click="showMap = !showMap">
          <v-icon class="pr-1" >directions</v-icon>
          {{ showMap ? 'Hide Direction' : 'Show Direction' }}
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="showMap && directionRoute.length && storePosition && customerPosition">
          <GoogleMap
            :latitude="customerPosition.latitude"
            :longitude="customerPosition.longitude"
            :zoom="13"
            :directionRoute="directionRoute"
            :multiplePosition="[storePosition, customerPosition]"
            mapType="direction"
            :height="400"
            :width="700"
          />
       
        </div>
     
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'OrderDirectionMap',
  props: {
    directionRoute: Array,
    storePosition: Object,
    customerPosition: Object,
    order_detail: Object
  },
  data() {
    return {
      showMap: false
    };
  }
};
</script>

<style scoped>
.v-card-title {
  align-items: center;
}
</style>
